import {Presenter} from '../../../program/support/with_presenter';
import {Subscription} from 'rxjs';
import {ExpandedPart, ExpandedPartsProvider} from '../../business/expanded_parts/ExpandedPartsProvider';
import {ChaptersRepository} from '../../business/chapters/ChaptersRepository';
import {Chapter} from '../../models/Chapter';

export class TimelinePresenter implements Presenter {
    public expandedParts: ExpandedPart[] = [];
    public chapters: Chapter[] = [];

    private expandedPartsSubscription: Subscription | undefined;
    private chaptersSubscription: Subscription | undefined;

    constructor(private expandedPartsProvider: ExpandedPartsProvider, private chaptersRepository: ChaptersRepository) {}

    public mount(): void {
        this.expandedPartsSubscription = this.expandedPartsProvider.expandedParts.subscribe(
            (expandedParts) => (this.expandedParts = expandedParts),
        );
        this.chaptersSubscription = this.chaptersRepository.chapters.subscribe((chapters) => {
            this.chapters = chapters;
        });
    }

    public unmount(): void {
        this.expandedPartsSubscription?.unsubscribe();
        this.chaptersSubscription?.unsubscribe();
    }

    public chaptersForExpandedPart(expandedPart: ExpandedPart): Chapter[] {
        return this.chapters.filter((chapter) => chapter.__expandedPartUuid === expandedPart.__uuid);
    }
}
